<template>
    <div class="post-index">
        <!-- header -->
        <Header />
        <!-- end header -->

        <!-- slider -->
        <Slider />
        <!-- end slider -->

        <!-- main content -->
        <!-- <header class="pt-5 border-bottom bg-light">
            <div class="container pt-md-1">
                <h1 class="bd-title mt-4 font-weight-bold"><i class="fa fa-book-open" aria-hidden="true"></i> BERITA
                </h1>
                <p class="bd-lead">{{ berita.judul }}</p>
            </div>
        </header> -->

        <!-- breadcrumb -->
        <section class="mt-5 py-2">
        <nav aria-label="breadcrumb">
            <ol class="container breadcrumb">
                <li class="breadcrumb-item">
                    <router-link :to="{ name: 'home' }" class="text-decoration-none"><i class="fa fa-home"></i> BERANDA
                    </router-link>
                </li>
                <li class="breadcrumb-item">
                    <router-link :to="{ name: 'Berita' }" class="text-decoration-none"> BERITA</router-link>
                </li>
                <li class="breadcrumb-item">
                    <a href="#kategoriberita" class="text-decoration-none"> KATEGORI</a>
                </li>
                <li class="breadcrumb-item active" aria-current="page">{{ upper(berita.kategori_nama) }}</li>
                <li class="breadcrumb-item" aria-current="page"></li>
            </ol>
        </nav>
        </section>
        <!-- end breadcrumb -->

        <section class="mt-5 py-2">
        <div class="container mt-5 mb-5">

            <div class="row">

                <div class="col-md-8">
                    <div v-if="berita.judul">
                        <div class="card border-0 shadow-sm rounded">
                            <div class="card-body">
                                <h3>{{ berita.judul }}</h3>
                                <hr>
                                <div v-if="berita.foto.includes('pdf')">
                                    <img :src="'http://192.168.123.97:3000/storage/berita/no-image.jpg'" class="w-100 rounded">
                                </div>
                                <div v-else>
                                    <img :src="berita.foto" class="w-100 rounded">
                                </div>

                                <div>
                                    <div class="mt-3" v-html="berita.isi"> </div>
                                </div>

                            </div>
                        </div>
                    </div>
                    <div v-else>
                        <div class="card border-0 shadow-sm rounded">
                            <div class="card-body">
                                <FacebookLoader/>
                            </div>
                        </div>
                    </div>

                </div>

                <div class="col-md-4">

                    <div class="position-sticky mt-4">
                    <!-- berita terbaru section -->
                    <div class="title mb-4">
                        <h5><i class="fa fa-calendar" aria-hidden="true"></i> Berita Terbaru</h5>
                    </div>

                    <div v-if="news.length > 0">
                        <div class="card mb-2 shadow-sm border-0">                        
                            <div class="card-body" style="overflow-y: auto; max-height: 370px;">
                                <div class="row py-2 px-3" v-for="berita in news" :key="berita.id">
                                    <div>
                                        <!-- <router-link :to="{name: 'detail_berita', params: {slug: berita.slug, kategori: berita.kategori_nama.toLowerCase()}}"
                                        class="text-dark text-decoration-none">
                                            <h6>{{ berita.judul }}</h6>
                                            <i class="fa fa-calendar" aria-hidden="true"></i> {{ dateTime(berita.tgl) }}
                                        </router-link> -->
                                        <a :href="$router.resolve({name: 'detail_berita', params: {slug: berita.slug, kategori: berita.kategori_nama.toLowerCase()}}).href"
                                        class="text-dark text-decoration-none">
                                            <h6>{{ berita.judul }}</h6>
                                            <!-- <i class="fa fa-calendar" aria-hidden="true"></i> {{ dateTime(berita.tgl) }} -->
                                        </a>
                                        <div class="text-justify text-muted" style="font-size: 12px;">
                                            <i class="far fa-calendar" aria-hidden="true"></i> {{ dateTime(berita.tgl) }} | {{ berita.kategori_nama }}
                                        </div>
                                    </div>
                                    <hr>
                                </div>                       
                            </div>
                        </div>
                    </div>

                    <!-- end berita terbaru section -->
                    </div>

                </div>

            </div>

        </div>
        </section>
        <!-- main content -->

        <!-- footer -->
        <Footer />
        <!-- end footer -->
    </div>
</template>

<script>
    //import content loader
    import {
        FacebookLoader
    } from 'vue-content-loader';

    //import axios
    import axios from 'axios';

    //import moment
    import moment from 'moment';

    //import hook onMounted from vue
    import { ref, onMounted } from 'vue';

    //import hook useRoute
    import { useRoute } from 'vue-router';

    //import component
    import Header from "@/components/Header";
    import Slider from "@/components/Slider";
    import Footer from "@/components/Footer";

    export default {
        name: 'BeritaDetailComponent',
        mounted() {  
            const nama_web = ref([]);
            //get nama web
            axios.get('/api/webconfig')
                .then(response => {
                    nama_web.value = response.data.data[0].nama_web;

                    document.title =  "Berita | " + nama_web.value;
                })  
        },

        components: {
            //loader component
            FacebookLoader,
            //component app
            Header,
            Slider,
            Footer
        },

        methods: {
        upper(value){
                    if(!value) return ''
                        value = value.toString()
                    return value.toUpperCase()
                },
        dateTime(value) {
            return moment(value).locale('id').format('L');
        }
        },
        

        setup() {
            
            //define state
            const berita      = ref({});
            const news        = ref([]);
            const news_loader = ref(6);
            const beritakota  = ref([]);

            //define route
            const route = useRoute();

            //run hook onMounted
            onMounted(() => {

                //get berita detail
                axios.get(`/api/berita/${route.params.slug}`)
                    .then(response => {
                        berita.value = response.data.data;
                    })

                //get berita terbaru
                axios.get(`/api/beranda/berita`)
                    .then(response => {
                        news.value = response.data.data.data;
                    })

                //get berita kota
                axios.get('https://api-splp.layanan.go.id/t/kotabogor.go.id/KotaBogor/1.0/berita?key=b3r1t4b0g0r', {
                    headers: {apikey: 'eyJ4NXQiOiJOVGRtWmpNNFpEazNOalkwWXpjNU1tWm1PRGd3TVRFM01XWXdOREU1TVdSbFpEZzROemM0WkE9PSIsImtpZCI6ImdhdGV3YXlfY2VydGlmaWNhdGVfYWxpYXMiLCJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiJ9.eyJzdWIiOiJia2FkQGtvdGFib2dvci5nby5pZCIsImFwcGxpY2F0aW9uIjp7Im93bmVyIjoiYmthZEBrb3RhYm9nb3IuZ28uaWQiLCJ0aWVyUXVvdGFUeXBlIjpudWxsLCJ0aWVyIjoiVW5saW1pdGVkIiwibmFtZSI6IndlYnNpdGVia2FkIiwiaWQiOjQzOSwidXVpZCI6IjM2NWE3OGFmLTkxMTAtNGIwZS05ZWQ2LWY1MTExNDA5MThiYiJ9LCJpc3MiOiJodHRwczpcL1wvc3BscC5sYXlhbmFuLmdvLmlkOjQ0M1wvb2F1dGgyXC90b2tlbiIsInRpZXJJbmZvIjp7IlVubGltaXRlZCI6eyJ0aWVyUXVvdGFUeXBlIjoicmVxdWVzdENvdW50IiwiZ3JhcGhRTE1heENvbXBsZXhpdHkiOjAsImdyYXBoUUxNYXhEZXB0aCI6MCwic3RvcE9uUXVvdGFSZWFjaCI6dHJ1ZSwic3Bpa2VBcnJlc3RMaW1pdCI6MCwic3Bpa2VBcnJlc3RVbml0IjpudWxsfX0sImtleXR5cGUiOiJQUk9EVUNUSU9OIiwic3Vic2NyaWJlZEFQSXMiOlt7InN1YnNjcmliZXJUZW5hbnREb21haW4iOiJrb3RhYm9nb3IuZ28uaWQiLCJuYW1lIjoiS290YUJvZ29yIiwiY29udGV4dCI6IlwvdFwva290YWJvZ29yLmdvLmlkXC9Lb3RhQm9nb3JcLzEuMCIsInB1Ymxpc2hlciI6ImFkbWluQGtvdGFib2dvci5nby5pZCIsInZlcnNpb24iOiIxLjAiLCJzdWJzY3JpcHRpb25UaWVyIjoiVW5saW1pdGVkIn1dLCJ0b2tlbl90eXBlIjoiYXBpS2V5IiwiaWF0IjoxNjYxNTA0ODcyLCJqdGkiOiI1ZWVjNzcyMi1iYzMwLTRiMTMtYWE4NC1mYThkMjEwODYwNWEifQ==.Orr7CaVKkU_j3CSXv2xjmL0Wif5p01XW9FmohIe4dwlztjVi9R8CBzv122-24yCeSZqGSzPWMUBASSq604SVKaIoTImbx1QouZ4YV92bdvQiw_B2PSVbSnmrmYRkrWYISRhcOBCbt7v6hp89LgT_weinS5fPm38mJA-kzPV2XKS0W1GctcYDFf_N0OoLrfmw1iplzVDPM-zV20hATsUEAfsOlhOAnVwdawH6MQpOMTvnZbGoNG9U7VONK4tKoWfg4N73PgnskQy_zT-YQn-vINg_Cxz07-569CsWQs3lGSNjs-cWh-86F_AtwZjfI5R-wIsXoz1cwijOxkowgfgAtA=='},
                    })
                    .then(response => {
                        beritakota.value = response.data;
                    })

            });

            return {
                berita,
                news,
                news_loader,
                beritakota,
            }

        }
    }
</script>